import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import QRCode from "qrcode.react";
import moment from "moment";
import { _t } from "js/utils/TranslationService";

import "./solicitud.css";
import "./solicitud-content-responsive.css";

class SolicitudContent extends React.PureComponent {
  render() {
    const idSegmento = parseInt(localStorage.getItem("idSegmento"));
    const { programLogo, beneficio, idSolicitud } = this.props;
    const codigosBeneficio = beneficio.codigosBeneficio || [];
    const { tipoCodigo = null } = beneficio;
    let codigoBeneficio = null;
    if (tipoCodigo && tipoCodigo === "FIJO") {
      codigoBeneficio = codigosBeneficio.find(codigo =>
        codigo.segmentos.includes(idSegmento)
      );
    }

    if (
      tipoCodigo &&
      (tipoCodigo === "IMPORTADOS" || tipoCodigo === "AUTOMATICOS")
    ) {
      codigoBeneficio = codigosBeneficio.find(
        codigo => codigo.idSolicitud === idSolicitud
      );
    }

    const codigoBeneficioText = codigoBeneficio ? codigoBeneficio.codigo : "";
    const tipoBeneficio = beneficio.idTipo ? beneficio.idTipo.tipo : "";

    return (
      <Paper className={"cupon-container content-container"}>
        <Grid container spacing={0} style={{ textAlign: "left" }}>
          <Grid
            item
            xs={12}
            md={3}
            className={"cupon-left-container cupon-inner-container"}
          >
            <Grid
              container
              spacing={24}
              className={"cupon-left-inner-container"}
            >
              <Grid item xs={6} md={12}>
                <img
                  src={programLogo}
                  alt="logo-programa"
                  className={"cupon-image"}
                />
              </Grid>
              <Grid item xs={6} md={12} className={"qr-container"}>
                <QRCode
                  value={`ID Solicitud: ${idSolicitud}`}
                  className={"qr-canvas"}
                />
                <br />
                <Typography
                  variant="subtitle2"
                  gutterBottom
                  className={"id-solicitud"}
                >
                  ID Solicitud: {idSolicitud}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            md={9}
            className={"cupon-right-container cupon-inner-container"}
          >
            <Grid container spacing={0}>
              <Grid item xs={12} className={"cupon-right-top"}>
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={6}>
                    <Grid container spacing={16}>
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          gutterBottom
                          className={"no-margin"}
                        >
                          {beneficio.nombre}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          variant={tipoBeneficio.length <= 14 ? "h3" : "h4"}
                          gutterBottom
                          className={"no-margin tipo"}
                        >
                          {tipoBeneficio}
                        </Typography>
                      </Grid>
                      {codigoBeneficio && (
                        <Grid item xs={12}>
                          <div className={"codigo"}>
                            <span className={"codigo-label"}>CÓDIGO:</span>
                            <div>{codigoBeneficioText}</div>
                          </div>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <Typography
                          variant="subtitle2"
                          gutterBottom
                          className={"no-margin descripcion"}
                        >
                          {beneficio.copete}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          variant="subtitle2"
                          gutterBottom
                          className={"no-margin descripcion"}
                        >
                          {beneficio.descripcion}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    className={"cupon-image-container content-image-container"}
                  >
                    <img
                      src={`${beneficio.logo ? beneficio.logo : programLogo}`}
                      alt="logo-beneficio"
                      className={"cupon-image"}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} className={"cupon-right-bottom"}>
                <Typography variant="subtitle1" gutterBottom>
                  <b>{_t("Condiciones:")}</b>
                </Typography>
                <Typography variant="subtitle2" gutterBottom>
                  {beneficio.condiciones}
                  <br />
                  <br />
                  {beneficio.tipoValidez === "SIEMPRE" && (
                    <span>{_t("El beneficio no tiene vencimiento.")}</span>
                  )}
                  {beneficio.tipoValidez === "POR_DIAS" && (
                    <span>
                      {`El beneficio es válido hasta el ${moment()
                        .add(beneficio.diasValidez, "d")
                        .format("DD/MM/YYYY")}.`}
                    </span>
                  )}
                  {beneficio.tipoValidez === "POR_FECHAS" && (
                    <span>
                      {`El beneficio es válido desde el ${moment(
                        beneficio.fechaValidezDesde
                      ).format("DD/MM/YYYY")} hasta el ${moment(
                        beneficio.fechaValidezHasta
                      ).format("DD/MM/YYYY")}.`}
                    </span>
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

SolicitudContent.propTypes = {
  classes: PropTypes.object
};

SolicitudContent.defaultProps = {};

export default SolicitudContent;
